// Static analytics data objects - screen_name will be injected dynamically where needed
export const NAV_ANALYTICS_DATA = {
  MAIN_TABS: {
    HOME: {
      product_area: 'foundation',
      sub_product_area: 'home screen',
      detail: 'navigate to feature landing screen',
      content: {
        name: 'home',
      },
      node: {
        type: 'main navigation tab',
      },
    },
    BENEFITS: {
      product_area: 'benefits',
      sub_product_area: 'benefits',
      detail: 'navigate to feature landing screen',
      content: {
        name: 'benefits',
      },
      node: {
        type: 'main navigation tab',
      },
    },
    GET_CARE: {
      product_area: 'get care',
      sub_product_area: 'care discovery',
      detail: 'navigate to feature landing screen',
      content: {
        name: 'get care',
      },
      node: {
        type: 'main navigation tab',
      },
    },
    JOURNEY: {
      product_area: 'health journey',
      sub_product_area: 'health journey',
      detail: 'navigate to feature landing screen',
      content: {
        name: 'journey',
      },
      node: {
        type: 'main navigation tab',
      },
    },
    SUPPORT: {
      product_area: 'foundation',
      sub_product_area: 'support',
      detail: 'navigate to feature landing screen',
      content: {
        name: 'support',
      },
      node: {
        type: 'main navigation tab',
      },
    },
  },
  SUBMENUS: {
    BENEFITS: {
      CLAIMS: {
        product_area: 'benefits',
        sub_product_area: 'claims',
        detail: 'navigate to feature menu item',
        content: {
          name: 'claims',
        },
        node: {
          type: 'main navigation drop down item',
        },
      },
      INSURANCE_COVERAGE: {
        product_area: 'benefits',
        sub_product_area: 'coverage',
        detail: 'navigate to feature menu item',
        content: {
          name: 'insurance coverage',
        },
        node: {
          type: 'main navigation drop down item',
        },
      },
      ADDITIONAL_BENEFITS: {
        product_area: 'benefits',
        sub_product_area: 'additional benefits',
        detail: 'navigate to feature menu item',
        content: {
          name: 'additional benefits',
        },
        node: {
          type: 'main navigation drop down item',
        },
      },
    },
    GET_CARE: {
      FIND_AND_PLAN_CARE: {
        product_area: 'get care',
        sub_product_area: 'care discovery',
        detail: 'navigate to feature menu item',
        content: {
          name: 'find and plan care',
        },
        node: {
          type: 'main navigation drop down item',
        },
      },
      ACCESS_CARE_NOW: {
        product_area: 'get care',
        sub_product_area: 'care discovery',
        detail: 'navigate to feature menu item',
        content: {
          name: 'access care & support',
        },
        node: {
          type: 'main navigation drop down item',
        },
      },
    },
    JOURNEY: {
      ABOUT_ME: {
        product_area: 'health journey',
        sub_product_area: 'health profile',
        detail: 'navigate to feature menu item',
        content: {
          name: 'health profile',
        },
        node: {
          type: 'main navigation drop down item',
        },
      },
      ACTIVITIES: {
        product_area: 'health journey',
        sub_product_area: 'activities',
        detail: 'navigate to feature menu item',
        content: {
          name: 'activities',
        },
        node: {
          type: 'main navigation drop down item',
        },
      },
      PROGRESS: {
        product_area: 'health journey',
        sub_product_area: 'health journey',
        detail: 'navigate to feature menu item',
        content: {
          name: 'progress',
        },
        node: {
          type: 'main navigation drop down item',
        },
      },
      HISTORY: {
        product_area: 'health journey',
        sub_product_area: 'health journey',
        detail: 'navigate to feature menu item',
        content: {
          name: 'history',
        },
        node: {
          type: 'main navigation drop down item',
        },
      },
      EXPLORE: {
        product_area: 'health journey',
        sub_product_area: 'care library',
        detail: 'navigate to feature menu item',
        content: {
          name: 'explore',
        },
        node: {
          type: 'main navigation drop down item',
        },
      },
    },
    SUPPORT: {
      CONNECT_WITH_US: {
        product_area: 'foundation',
        sub_product_area: 'support',
        detail: 'navigate to feature menu item',
        content: {
          name: 'need help? contact us',
        },
        node: {
          type: 'main navigation drop down item',
        },
      },
      FORMS_AND_FILES: {
        product_area: 'foundation',
        sub_product_area: 'support',
        detail: 'navigate to feature menu item',
        content: {
          name: 'forms and files',
        },
        node: {
          type: 'main navigation drop down item',
        },
      },
      FAQ_GLOSSARY: {
        product_area: 'foundation',
        sub_product_area: 'support',
        detail: 'navigate to feature menu item',
        content: {
          name: 'faq and glossary',
        },
        node: {
          type: 'main navigation drop down item',
        },
      },
    },
    USER_SETTINGS: {
      ACCOUNT_MANAGEMENT: {
        product_area: 'foundation',
        sub_product_area: 'user settings',
        detail: 'navigate to feature menu item',
        content: {
          name: 'account management',
        },
        node: {
          type: 'main navigation drop down item',
        },
      },
      COORDINATION_OF_BENEFITS: {
        product_area: 'foundation',
        sub_product_area: 'user settings',
        detail: 'navigate to feature menu item',
        content: {
          name: 'coordination of benefits',
        },
        node: {
          type: 'main navigation drop down item',
        },
      },
    },
  },
};
